import { render, staticRenderFns } from "./List.vue?vue&type=template&id=96aa839a&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96aa839a')) {
      api.createRecord('96aa839a', component.options)
    } else {
      api.reload('96aa839a', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=96aa839a&", function () {
      api.rerender('96aa839a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/lot/List.vue"
export default component.exports